export const cleanLocationName = (name) => {
	const lastCommaIndex = name.lastIndexOf(',');
	return lastCommaIndex !== -1 ? name.slice(0, lastCommaIndex) : name;
};
